/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForIntegratedTool extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForIntegratedTool");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForIntegratedTool.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForIntegratedTool>): ServiceAccountNativeDetailsBaseForIntegratedTool {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForIntegratedTool(), model);
        ServiceAccountNativeDetailsBaseForIntegratedTool.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForIntegratedTool>): ServiceAccountNativeDetailsBaseForIntegratedTool {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForIntegratedTool.newInstance(<ServiceAccountNativeDetailsBaseForIntegratedTool> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForIntegratedTool) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForIntegratedTool): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForIntegratedTool.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
